// react-fast-marquee ships CJS only; Vite 8's Rolldown interop hands its
// default import back as the module object. Unwrap so either shape works.
import MarqueeImport from "react-fast-marquee";

const Marquee = MarqueeImport.default ?? MarqueeImport;

export default Marquee;
